<template>
    <div>
        <el-dialog
            title="管理分类"
            :visible.sync="visible"
            :before-close="handleCloseAll"
            :close-on-click-modal="false"
            width="50%"
            @open="onOpen">
            <el-divider content-position="left">拖动可对栏目排序  点击可管理分类中的网址</el-divider>
            <draggable v-model="types" class="type-container">
                <div
                    class="type-item"
                    v-for="(type) in types"
                    :key="type.id">
                    <el-tag @click="handleClick(type)">
                        <span>{{type.name}}</span>
                    </el-tag>
                </div>
            </draggable>
            <el-divider></el-divider>
            <span></span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">返 回</el-button>
                <el-button type="primary" @click="handleSave">保 存</el-button>
            </span>
        </el-dialog>
        <ManageCommon
            v-on:close-all="handleCloseAll"
                :visible="manageVisible"
                :defaultSites="manageType.defaultSites"
                :customSites="manageType.customSites"
                @close="manageVisible=false"
                @save="onManageSave"></ManageCommon>
    </div>

</template>

<script>
import draggable from 'vuedraggable'
import ManageCommon from '../components/ManageCommon.vue'
import cs from "../utils/customSite";

export default {
    components: {
        draggable,
        ManageCommon
    },
    data() {
        return {
            types: [],
            manageVisible: false,
            manageType: {defaultSites:[], customSites:[]}
        }
    },
    props: {
        visible: Boolean,
        typeList: Array
    },
    methods: {
        onOpen() {
            this.types = this.typeList
        },
        handleClose() {
            this.$emit('close')
        },
        handleCloseAll() {
            this.$emit('close')
            this.$emit('close-all')
        },
        handleSave() {
            let r = []
            for (let i = 0; i < this.types.length; i++) {
                const type = this.types[i];
                r.push(type.id)
            }

            this.$emit('save', r)
            this.handleClose()
        },
        async handleClick(type) {
            if(type.defaultSites === undefined) {
                await type.processType(type)
            }

            this.manageType = type
            this.manageVisible = true
        },
        onManageSave(customs) {
            console.log(customs)
            this.manageType.customSites = customs
            cs.saveUserCustom(customs, this.manageType.id)
            this.manageType.processType(this.manageType)
        }
    }
}
</script>

<style scoped>
.type-container {
    /* display: flex; */
}
.type-item {
    padding: 4px;
    height: 28px;
    display: inline;
    align-items: center;
    width: 16.66666667%;
}

.type-item > span {
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/ManageType.vue